export const BreadCrumbs = 'atlantis-breadcrumbs';
export const BreadCrumbsItem = 'atlantis-breadcrumb-item';